<fui-rows>
    <fui-row [label]="title">
        <!--<fui-content-layout-header-control slot="after">
            <div class="status-panel">
                <div class="status-panel-summary">
                    <fui-ellipsis-loader *ngIf="status === Status.LOADING"></fui-ellipsis-loader>
                    <div class="status-panel-summary-status status-panel-summary-status-required"
                         *ngIf="status === Status.REQUIRED">Required
                    </div>
                    <div class="status-panel-summary-status status-panel-summary-status-pending"
                         *ngIf="status === Status.PENDING">Pending
                    </div>
                    <div class="status-panel-summary-status status-panel-summary-status-notReady"
                         *ngIf="status === Status.NOT_READY">Not Ready
                    </div>
                    <div class="status-panel-summary-status status-panel-summary-status-failed"
                         *ngIf="status === Status.FAILED_TO_LOAD">Failed
                    </div>
                    <div class="status-panel-summary-tick"
                         [ngClass]="{'status-panel-summary-tick-required': status === Status.REQUIRED, 'status-panel-summary-tick-pending': status === Status.PENDING, 'status-panel-summary-tick-complete': status === Status.COMPLETE}"></div>


                </div>
            </div>
        </fui-content-layout-header-control>
        -->
        <ng-content></ng-content>

    </fui-row>
</fui-rows>

